<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Journal</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="journals"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          name="journal"
          label="name"
          v-model="formData.journal_id"
          placeholder="Pilih Master Journal"
        />
        <span class="text-danger text-sm">{{ errors.first("journal") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Pembagian</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="pembagians"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          name="distribution"
          label="name"
          v-model="formData.pembagian_id"
          placeholder="Pilih Pembagian Journal"
        />
        <span class="text-danger text-sm">{{ errors.first("distribution") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Jenis Transaksi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="jenisTransaksis"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          name="transaction type"
          label="name"
          v-model="formData.jenis_id"
          placeholder="Pilih Jenis Transaksi"
        />
        <span class="text-danger text-sm">{{ errors.first("transaction type") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      formData: {
        jenis_id: null,
        journal_id: null,
        pembagian_id: null,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Setting Journal" : "Tambah Setting Journal";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    journals() {
      return this.$store.state.journal.masterList;
    },
    pembagians() {
      return this.$store.state.journal.pembagianList;
    },
    jenisTransaksis() {
      return this.$store.state.transaksi.jenisList;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.jenis_id !== null &&
        this.formData.journal_id !== null &&
        this.formData.pembagian_id !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.jenis_id = this.passData.jenis ? this.passData.jenis.id : null;
        this.formData.journal_id = this.passData.journal
          ? this.passData.journal.id
          : null;
        this.formData.pembagian_id = this.passData.pembagian
          ? this.passData.pembagian.id
          : null;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.jenis_id = null;
      this.formData.journal_id = null;
      this.formData.pembagian_id = null;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.$store
        .dispatch("journal/cudSetting", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Setting Journal Sukses!"
                : "Tambah Setting Journal Sukses!",
            text:
              this.passData !== null
                ? `Setting Journal ${v.name} Berhasil diedit`
                : `Setting Journal ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>
